import { Link } from "react-router-dom";

/**
 * FanFuel wordmark — an ember "fuel node" glyph + type.
 */
export const Logo = ({ className = "", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="brand-logo"
    className={`group inline-flex items-center gap-2.5 ${className}`}
  >
    <span className="relative flex h-8 w-8 items-center justify-center">
      <span className="absolute inset-0 rounded-lg bg-ff-ember/15 blur-md transition-all group-hover:bg-ff-ember/30" />
      <svg viewBox="0 0 24 24" className="relative h-6 w-6" fill="none">
        <path
          d="M6 3h9l-1.5 6H18l-9 12 2-8H6z"
          fill="#FF4B22"
          stroke="#FF4B22"
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </svg>
    </span>
    <span className="font-display text-xl font-extrabold tracking-tight text-ff-ivory">
      Fan<span className="text-ff-ember">Fuel</span>
    </span>
  </Link>
);

export default Logo;
